/** 모듈형 연동 대상 — 랜딩·/try·/docs 공통 (평문 우선) */

export type IntegrationModule = {
  id: string;
  icon: 'vms' | 'webhook' | 'mqtt' | 'fusion' | 'edge' | 'openapi';
  title: string;
  plain: string;
  docsPath: string;
  docHint?: string;
};

export const INTEGRATION_MODULES: IntegrationModule[] = [
  {
    id: 'vms',
    icon: 'vms',
    title: '기존 관제·녹화',
    plain: '카메라와 녹화기는 그대로 두고, 조건에 맞는 순간만 알림으로 보냅니다.',
    docsPath: '/docs/vms-iot-integration',
    docHint: 'INTEGRATION_VMS_IOT_EDGE.md',
  },
  {
    id: 'webhook',
    icon: 'webhook',
    title: '보안관제·티켓',
    plain: '보안센터·헬프데스크가 받기 쉬운 알림 항목으로 맞춰 전달합니다.',
    docsPath: '/docs/vms-iot-integration',
  },
  {
    id: 'mqtt',
    icon: 'mqtt',
    title: '센서·게이트',
    plain: '문·센서 신호와 영상 알림을 같은 규칙으로 묶어 운영합니다.',
    docsPath: '/docs/vms-iot-integration',
    docHint: 'FUSION_INTEL_BUS_TOPICS.md',
  },
  {
    id: 'fusion',
    icon: 'fusion',
    title: '여러 출처 한곳에',
    plain: '카메라·레이더·외부 시스템 알림을 한 형식으로 모아 봅니다.',
    docsPath: '/docs/edge-and-cloud',
    docHint: 'FUSION_CONNECTORS_INGEST_CONTRACT.md',
  },
  {
    id: 'edge',
    icon: 'edge',
    title: '현장 장비',
    plain: '현장에서 먼저 판단하고, 필요할 때만 위(중앙)로 짧은 알림을 올립니다.',
    docsPath: '/docs/edge-and-cloud',
    docHint: 'LAYERED_TICK_METRICS.md',
  },
  {
    id: 'openapi',
    icon: 'openapi',
    title: '파트너·개발 연동',
    plain: '표준 인터페이스 문서와 예시로 SI·다른 솔루션이 붙기 쉽게 합니다.',
    docsPath: '/docs/api-and-sdk',
    docHint: 'openapi_console.json',
  },
];
